/* Wallderinska — allt som dras i sidled: plaggrader och recensionsband.
   Skriven 2026-08-07 på Maries order.

   VARFÖR FILEN FINNS: temats eget karusellskript definierar <scroll-carousel>
   och pilknapparna som egna element, men de kommer inte igång på startsidan.
   Klassen is-scrollable sätts aldrig och ett klick på pilen gör ingenting.
   Det här skriptet står på egna ben.

   Maries besked 7 augusti: samma utseende och samma funktion på alla band.
   Recensionsbanden hade tidigare en ren dekorationspil, en pil som inte gick
   att trycka på. Den är borttagen. Alla band har nu samma riktiga knappar
   som plaggraderna, med samma pilform ur temats eget ikonbibliotek.

   VAD DET GÖR:
   pilarna flyttar bandet ett kort i taget, mjukt.
   plaggraderna glider 32 px i sekunden av sig själva.
   ett recensionsband som inte redan rör sig får samma drift. Kundrösterna på
   startsidan har ett eget skript som redan glider och loopar sömlöst, det
   lämnas i fred.
   driften stannar vid muspekare över bandet, vid drag, när bandet är utanför
   skärmen och när fliken ligger i bakgrunden.
   den som bett sin dator om mindre rörelse får inga drifter, bara pilar.

   RÖR INTE: bildkarusellen på produktsidan. Den har egna pilar och prickar. */
(function () {
  'use strict';

  var SPEED = 32;
  var PAUSE_AFTER = 2500;
  var END_HOLD = 1500;
  var BANDS = '.wrc-scroller, .w-reviews-marquee__scroller, .wsm-scroller';
  var LEFT = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg>';
  var RIGHT = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M5 1l8 8-8 8" stroke="currentColor" stroke-linecap="square"/></svg>';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function gapOf(el) {
    var s = getComputedStyle(el);
    var g = parseFloat(s.columnGap);
    if (isNaN(g)) g = parseFloat(s.gap);
    return isNaN(g) ? 0 : g;
  }

  function maxOf(el) { return Math.max(0, el.scrollWidth - el.clientWidth); }

  function stepOf(el, inner) {
    var host = inner || el;
    var c = host.firstElementChild;
    if (!c) return Math.round(el.clientWidth * 0.5);
    return Math.round(c.getBoundingClientRect().width + gapOf(host));
  }

  /* Gemensam motor. el = det som skrollar. prev/next = knappar. */
  function drive(el, prev, next, opts) {
    opts = opts || {};
    var held = 0, hovered = false, dragging = false, visible = true, endAt = 0, back = false;

    function hold(ms) { held = Date.now() + (ms || PAUSE_AFTER); }

    function sync() {
      if (opts.loops) { return; }
      var max = maxOf(el);
      if (prev) prev.disabled = el.scrollLeft <= 2;
      if (next) next.disabled = max <= 2 || el.scrollLeft >= max - 2;
    }

    function go(dir) {
      hold();
      back = false;
      endAt = 0;
      el.scrollBy({ left: dir * stepOf(el, opts.inner), behavior: 'smooth' });
      setTimeout(sync, 500);
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); }, true);
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); }, true);

    el.addEventListener('scroll', sync, { passive: true });
    el.addEventListener('wheel', function () { hold(); }, { passive: true });
    el.addEventListener('touchstart', function () { hold(6000); }, { passive: true });

    if (fine) {
      el.addEventListener('mouseenter', function () { hovered = true; });
      el.addEventListener('mouseleave', function () { hovered = false; hold(800); });
      if (!el.__wdrag) {
        el.__wdrag = true;
        el.style.cursor = 'grab';
        var x0 = 0, l0 = 0, moved = false;
        el.addEventListener('mousedown', function (e) {
          dragging = true; moved = false; x0 = e.pageX; l0 = el.scrollLeft;
          el.style.cursor = 'grabbing'; e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var dx = e.pageX - x0;
          if (Math.abs(dx) > 3) moved = true;
          el.scrollLeft = l0 - dx;
        });
        window.addEventListener('mouseup', function () {
          if (!dragging) return;
          dragging = false; el.style.cursor = 'grab'; hold();
        });
        el.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); e.stopPropagation(); }
        }, true);
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.15 }).observe(el);
    }

    sync();
    if (reduced || opts.noDrift) return;

    var last = null, pos = el.scrollLeft;
    function frame(now) {
      if (last === null) last = now;
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;

      if (hovered || dragging || !visible || document.hidden || Date.now() < held) {
        pos = el.scrollLeft;
      } else {
        var max = maxOf(el);
        if (max <= 1) {
          pos = 0;
        } else if (back) {
          pos = el.scrollLeft;
          if (pos <= 1) { back = false; hold(800); }
        } else if (el.scrollLeft >= max - 1) {
          if (!endAt) {
            endAt = Date.now();
          } else if (Date.now() - endAt > END_HOLD) {
            endAt = 0; back = true;
            el.scrollTo({ left: 0, behavior: 'smooth' });
          }
          pos = el.scrollLeft;
        } else {
          endAt = 0;
          pos += SPEED * dt;
          if (pos > max) pos = max;
          el.scrollLeft = pos;
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* Plaggraderna. Knapparna finns redan i temats html. */
  function setupRow(row) {
    var el = row.querySelector('.product-list--carousel');
    if (!el || el.__wsc) return;
    el.__wsc = true;
    el.style.scrollSnapType = 'none';
    drive(el, row.querySelector('carousel-prev-button button'), row.querySelector('carousel-next-button button'), {});
  }

  /* Recensionsbanden. Här finns inga knappar, så vi sätter dit dem. */
  function makeButton(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wsc-band-arrow wsc-band-arrow--' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', dir < 0 ? 'Föregående' : 'Nästa');
    b.innerHTML = dir < 0 ? LEFT : RIGHT;
    return b;
  }

  function setupBand(sc) {
    if (sc.__wscBand) return;
    if (!sc.clientWidth) return;
    var inner = sc.firstElementChild;
    if (!inner || !inner.firstElementChild) return;   /* vänta tills bandet är fyllt */
    sc.__wscBand = true;

    var host = sc.closest('.wsm-mask') || sc;
    var wrap = document.createElement('div');
    wrap.className = 'wsc-band';
    host.parentNode.insertBefore(wrap, host);
    wrap.appendChild(host);

    var prev = makeButton(-1), next = makeButton(1);
    wrap.appendChild(prev);
    wrap.appendChild(next);

    /* Rör bandet sig redan av sig självt? Kolla över en kort stund. */
    var a = sc.scrollLeft;
    setTimeout(function () {
      var loops = Math.abs(sc.scrollLeft - a) > 1;
      drive(sc, prev, next, { inner: inner, loops: loops, noDrift: loops });
    }, 700);
  }

  function scan() {
    var rows = document.querySelectorAll('.floating-controls-container');
    for (var i = 0; i < rows.length; i++) setupRow(rows[i]);
    var bands = document.querySelectorAll(BANDS);
    for (var j = 0; j < bands.length; j++) setupBand(bands[j]);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  setTimeout(scan, 1200);
  setTimeout(scan, 2500);
  setTimeout(scan, 5000);
})();
